<template>
 <div  v-if="this.$route.path !== '/login'">
  <v-app id="inspire">
    <!-- #8a31e2 -->
    <!-- color="purple darken-1" -->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app

      style="background-color:#8a31e2"
      dark
    >
          
     
       <v-app-bar-nav-icon @click.stop="drawer = !drawer"  v-if="this.$route.path == '/score/dashboard'"></v-app-bar-nav-icon >
    
        <v-btn  v-if="this.$route.path != '/score/dashboard' " icon @click="backToDasboard()">
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
        <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
        >
          <span class="hidden-sm-and-down">ISBB Cambodia</span>
        </v-toolbar-title>
    
      <v-spacer></v-spacer>
      <v-btn icon @click="Logout()">
        <v-icon>mdi-power</v-icon>
      </v-btn>

    </v-app-bar>
  <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >

      <v-list dense>
        <v-list-item class="mt-2" >
          <v-spacer />
            <v-toolbar-side-icon >
              <v-img class="mr-3" src="@/assets/isbb.jpg" height="60px" width="70px"> 
              </v-img>

            </v-toolbar-side-icon>
            <v-spacer />
        </v-list-item>
     
        <v-list-item class="mt-3"
          @click="goClasses()"
        >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
                Class
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item
        @click="goToAccount()" 
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
                Account
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
       <v-list-item @click="Logout()" >
          <v-list-item-icon>
            <v-icon>mdi-power</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
                Logout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
   
      </v-list>
      <template v-slot:append>
          <div class="pa-2">
            <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-information</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Version : 1.1.1
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          </div>
        </template>
    </v-navigation-drawer>

    <v-overlay
     v-model="overlay"
      class="align-center justify-center"
    >
    <v-progress-circular
    color="purple"
        indeterminate
        size="40"
      ></v-progress-circular>
    </v-overlay>
         
    <v-app>
    <router-view>

  </router-view>
  
   
  </v-app>
  </v-app>
 </div>
  <div v-else>

    <router-view>

  </router-view>

  </div>


</template>

<script>


export default {
  name: 'App',

  components: {
 
  },

  data: () => ({
    //
      checkIsMobile : false,
       drawers: true,
           overlay:false,
           drawer: false,
           group: null,
           awesome:false,
            items: [
       
        { icon: 'mdi-contacts', text: 'Contacts' },
        { icon: 'mdi-history', text: 'Frequently contacted' },
        { icon: 'mdi-content-copy', text: 'Duplicates' }
    
       
      ]
  }),

  computed : {

  
    hide () {
      return this.$route.path === '/login' || this.$route.path === '/register'; 
    }
   
  },
  mounted () {
     if(this.$vuetify.breakpoint.mobile == false)
     {
       this.drawer = true
       this.checkIsMobile = true
     }
      
    },
  methods:{
       Logout(){   
              this.overlay = true
               setTimeout(() => {
                this.overlay = false
                localStorage.removeItem('hasLogin')
                this.$router.push({ name: "login" });
              }, 1000)
           
        },

        goClasses(){
          this.$router.push({ name: "dashboard" });
        },
        goToAccount(){
            this.$router.push({ name: "accountstudent" });
        },
        backToDasboard(){
          this.$router.push({ name: "dashboard" });
        }


  },
  

};
</script>
